import styled from "styled-components";
import { Row, Col } from "antd";
import { RAButtonPrimary } from "@/components/customs";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { RAImage } from "@/components/customs";
import { useTrackVisibility } from "react-intersection-observer-hook";
import { useState, useEffect } from "react";
import { HeaderSection } from "../../Cards";

export function ContactUsJoinTeam({ joining_our_team = {}, available_positions = {}, refCareer }) {
	const [ref, { isVisible }] = useTrackVisibility();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setVisible(true);
		}
	}, [isVisible]);
	return (
		<HomeServicesContainer ref={ref} style={{ opacity: visible ? 1 : 0 }}>
			<EachRow
				justify="center"
				align="middle"
				className={`${visible && "animate__animated animate__fadeInUp"}`}
				gutter={[
					{ xl: 60, lg: 50, md: 40, sm: 30, xs: 0 },
					{ xl: 30, lg: 30, md: 24, sm: 20, xs: 20 },
				]}
			>
				<Col className="image-left" xl={12} lg={12} md={24} sm={24} xs={24}>
					<RAImage
						url={joining_our_team?.photo || PATH_PUBLIC_IMAGES.contact_image_3}
						width="100%"
						height="100%"
						borderRadius="16px"
					/>
				</Col>
				<Col xl={12} lg={12} md={24} sm={24} xs={24}>
					<WrapperContent>
						<HeaderSection
							title={joining_our_team?.title || ""}
							description={joining_our_team?.description || ""}
						/>
					</WrapperContent>
				</Col>
			</EachRow>
			<EachRow
				justify="center"
				align="middle"
				className={`${visible && "animate__animated animate__fadeInUp"}`}
				gutter={[
					{ xl: 60, lg: 50, md: 40, sm: 30, xs: 0 },
					{ xl: 30, lg: 30, md: 24, sm: 20, xs: 20 },
				]}
				ref={refCareer}
			>
				<Col
					className="image-left"
					xl={{ span: 12, order: 2 }}
					lg={{ span: 12, order: 2 }}
					md={{ span: 24, order: 1 }}
					sm={{ span: 24, order: 1 }}
					xs={{ span: 24, order: 1 }}
				>
					<RAImage
						url={available_positions?.photo || PATH_PUBLIC_IMAGES.contact_image_3}
						width="100%"
						height="100%"
						borderRadius="16px"
					/>
				</Col>
				<Col
					xl={{ span: 12, order: 1 }}
					lg={{ span: 12, order: 1 }}
					md={{ span: 24, order: 2 }}
					sm={{ span: 24, order: 2 }}
					xs={{ span: 24, order: 2 }}
				>
					<WrapperContent>
						<HeaderSection
							title={available_positions?.title || ""}
							description={available_positions?.description || ""}
						/>
					</WrapperContent>
					<Row>
						<RAButtonPrimary
							target="_blank"
							onClick={() => window.open(available_positions?.button_link || "", "_blank")}
							title={available_positions?.button_content || "VIEW ALL JOB"}
						/>
					</Row>
				</Col>
			</EachRow>
		</HomeServicesContainer>
	);
}

const EachRow = styled(Row)`
	margin: 50px 0;
	@media (max-width: 797px) {
		margin: 32px 0;
	}
	@media (max-width: 575px) {
		margin: 16px 0;
	}
`;
const HomeServicesContainer = styled.div`
	width: 100%;
	max-width: 1442px;
	padding-top: 84px;
	.image-left {
		padding-right: 40px;
		height: 360px;
	}
	.image-right {
		padding-left: 40px;
		height: 360px;
	}
	@media (max-width: 767px) {
		padding-top: 0px;
		.image-left {
			padding-right: 0;
			height: 210px;
		}
		.image-right {
			padding-left: 0;
			height: 210px;
		}
	}
	@media (max-width: 575px) {
		padding-top: 0px;
	}
`;
const WrapperContent = styled.div`
	margin-bottom: 20px;
`;
